import clsx from 'clsx';
import styles from './check-more.module.css'

function CheckMoreButton({onClick = () => null}) {
    return <div onClick={onClick} className={clsx(styles.root)}>
        <span className={clsx(styles.chevron)}></span>
        <span className={clsx(styles.text)}>check more</span>
    </div>;
}

export default CheckMoreButton